


















































































import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import rd from "@/modules/vRoutedefs";

@Component
export default class HseGuidelineInfo extends CommonBase {
  readonly hseGuidelinesTo = rd.system.hseguidelines.path;
}
